<h1 mat-dialog-title>{{ data.mode === 'pix' ? 'Pagar com Pix' : 'Pagar com boleto' }}</h1>

<div mat-dialog-content>
  <section *ngIf="data.mode === 'pix'" class="payment-modal-content">
    <div class="alert alert-success">
      <h3><strong>Instruções para pagamento</strong></h3>
      <div class="row">
        <div class="col-xs-6 col-md-6">
          <h3><strong>Celular</strong></h3>
          <ul>
            <li>Abra o aplicativo do seu banco</li>
            <li>Escaneie o QR Code apresentado</li>
            <li>Confira os dados de pagamento no aplicativo</li>
            <li>Conclua a transação no aplicativo</li>
          </ul>
        </div>
        <div class="col-xs-6 col-md-6">
          <h3><strong>Computador ou notebook</strong></h3>
          <ul>
            <li>Abra o site do seu banco</li>
            <li>Clique no botão "Copiar código Pix"</li>
            <li>Cole o texto copiado na opção "Pix Copia e cola" ou similar.</li>
            <li>Confira os dados de pagamento no site</li>
            <li>Conclua a transação no site do seu banco</li>
          </ul>
        </div>
      </div>

    </div>

    <div *ngIf="pix; else pixUnavailable" class="pix-layout">
      <img [src]="'data:image/png;base64,' + pix.IMAGEM_QR_CODE" alt="QR Code Pix" class="pix-qrcode">

      <div class="payment-details">
        <div>
          <span>Vencimento</span>
          <strong>{{ pix.DATA_VENCIMENTO | date: 'dd/MM/yyyy HH:mm:ss' }}</strong>
        </div>
        <div>
          <span>Valor</span>
          <strong>{{ pix.VALOR | currency: 'BRL' }}</strong>
        </div>
      </div>
    </div>

    <ng-template #pixUnavailable>
      <div class="alert alert-warning text-center">Dados do Pix indisponíveis para esta cobrança.</div>
    </ng-template>
  </section>

  <section *ngIf="data.mode === 'boleto'" class="payment-modal-content">
    <div class="alert alert-info">
      <h3><strong>Importante:</strong></h3>
      <ul>
        <li>O pagamento por boleto pode demorar até 3 dias para identificação do pagamento.</li>
        <li>Caso precise que o pagamento seja identificado imediatamente, prefira pagamento por Cartão ou Pix.</li>
      </ul>
    </div>

    <div class="payment-details boleto-details">
      <div>
        <span>Vencimento</span>
        <strong>{{ boletoDueDate | date: 'dd/MM/yyyy' }}</strong>
      </div>
      <div>
        <span>Valor</span>
        <strong>{{ boletoValue | currency: 'BRL' }}</strong>
      </div>
      <div>
        <span>Linha digitável</span>
        <strong class="boleto-code">{{ boletoCode || 'Indisponível' }}</strong>
      </div>
    </div>

    <iframe
      *ngIf="pdfBoletoSanitizado"
      class="boleto-frame"
      [src]="pdfBoletoSanitizado"
      title="Visualização do boleto"
    ></iframe>
  </section>
</div>

<div mat-dialog-actions align="start">
  <button *ngIf="data.mode === 'pix'" mat-raised-button color="primary" type="button" [disabled]="!pix?.COPIA_COLA" (click)="copiarQrCodePix()">
    Copiar código Pix
  </button>
  <button *ngIf="data.mode === 'boleto'" mat-raised-button color="primary" type="button" [disabled]="!boletoCode" (click)="copiarCodigoBarrasBoleto()">
    Copiar linha digitável
  </button>
  <button *ngIf="data.mode === 'boleto'" mat-raised-button color="accent" type="button" [disabled]="!pdfBoleto" (click)="imprimirBoleto()">
    Imprimir boleto
  </button>
  <button mat-button mat-dialog-close type="button">Fechar</button>
</div>
